/* eslint-disable max-statements */
import React, { useState, useRef } from "react";
import LoginControl from "./control";
import PropTypes from "prop-types";
import { mobileNumberValidator } from "../../../utils/validators/mobile-number-validator";
import { NUMBER } from "../../../constants/app-constants";
import { NETWORK_ERROR_CONSTANTS } from "../login-signup-v2/constants";
import { DEFAULT_SF_LANDING_SOURCE } from "../../../constants/sf-landing-constants";

const LoginComponent = ({
    mobile,
    isLoggedIn,
    onClose,
    history,
    sendOtp,
    verifyOtp,
    onSuccessLogin = () => {}
}) => {
    const [showOtpField, setShowOtpField] = useState(false);
    const [custPhone, setCustPhone] = useState(mobile || "");
    const [otp, setOtp] = useState("");
    const [showLoader, setShowLoader] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [allowWhatsapp, setAllowWhatsapp] = useState(true);
    const [showResendOtp, setShowResendOtp] = useState(false);

    // eslint-disable-next-line no-undef
    const searchParams = new URLSearchParams(history?.location?.search);
    const source = searchParams.get("source") || DEFAULT_SF_LANDING_SOURCE;

    const isNextDisabled = !mobileNumberValidator(custPhone);

    const phoneRef = useRef();
    const otpRef = useRef();
    const toggleRef = useRef();

    const onPhoneChange = (e) => {
        const number = e.target.value;
        setCustPhone(number);
    };

    const onOtpChange = (e) => {
        const number = e.target.value;
        setOtp(number);
        setErrorMessage("");
    };

    const focusOtp = () => {
        window.setTimeout(() => {
            if (otpRef && otpRef.current) {
                otpRef.current.focus();
            }
        }, NUMBER.THREE_HUNDRED);
    };

    const onGetOTP = async () => {
        setShowOtpField(true);
        focusOtp();

        await sendOtp({
            isLoggedIn,
            phoneNumber: custPhone,
            leadSource: source
        });
    };

    const onWhatsappChange = (e) => {
        const {
            target: { checked }
        } = e;
        setAllowWhatsapp(checked);
    };

    const resetErrorMessage = () => {
        setErrorMessage("");
    };

    const onOtpVerify = async () => {
        resetErrorMessage();
        setShowLoader(true);
        verifyOtp({ phone_number: custPhone, otp })
            .then((response) => {
                if (response.error) {
                    const {
                        error: { error_message: errormessage }
                    } = response;
                    setErrorMessage(errormessage);
                    setShowLoader(false);
                    return;
                }
                const responseData = response?.detail || {};
                const { token = "" } = responseData;
                onSuccessLogin();
                if (token) {
                    history.push(`/seller-financing/${token}`);
                }
            })
            .catch((error) => {
                const errorCode =
          (error && error.errors && error.errors[0] && error.errors[0].error) ||
          (error && error.message) ||
          "";
                setErrorMessage(
                    (errorCode || "").toLowerCase() ===
            NETWORK_ERROR_CONSTANTS.NETWORK_ERROR
                        ? NETWORK_ERROR_CONSTANTS.INTERNET_ISSUE
                        : errorCode
                );
            })
            .finally(() => {
                setShowLoader(false);
            });
    };

    const onCompleteTimer = () => {
        setShowResendOtp(true);
    };

    return (
        <LoginControl
            onClose={onClose}
            showOtpField={showOtpField}
            custPhone={custPhone}
            otpRef={otpRef}
            otp={otp}
            phoneRef={phoneRef}
            toggleRef={toggleRef}
            isNextDisabled={isNextDisabled}
            showLoader={showLoader}
            onPhoneChange={onPhoneChange}
            onOtpChange={onOtpChange}
            onGetOTP={onGetOTP}
            allowWhatsapp={allowWhatsapp}
            errorMessage={errorMessage}
            onWhatsappChange={onWhatsappChange}
            onOtpVerify={onOtpVerify}
            showResendOtp={showResendOtp}
            onCompleteTimer={onCompleteTimer}
            setShowResendOtp={setShowResendOtp}
            setShowOtpField={setShowOtpField}
            isOTPInvalid={!!errorMessage}
            setErrorMessage={setErrorMessage}
            isEditable
        />
    );
};

LoginComponent.propTypes = {
    mobile: PropTypes.string,
    isLoggedIn: PropTypes.bool,
    history: PropTypes.object,
    onClose: PropTypes.func,
    sendOtp: PropTypes.func,
    verifyOtp: PropTypes.func,
    onSuccessLogin: PropTypes.func
};

export default LoginComponent;
